import { render, staticRenderFns } from "./FrameAnimationBlock.vue?vue&type=template&id=48c4da36"
import script from "./FrameAnimationBlock.vue?vue&type=script&lang=js"
export * from "./FrameAnimationBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports